'use client';

import React from 'react';
import styled from '@emotion/styled';
import { Color } from '../../../../styles/Color';
import { ErrorMessages } from '../../../../utils/errorMessages';
import { Css, Responsive, RefreshIcon, TextButton } from '../../../../ui';

interface IErrorMessage {
	message?: string;
}

const reloadPage = () => {
	window.location.reload();
};

export default function ErrorMessage({ message }: IErrorMessage) {
	return (
		<Root>
			<Title>Something went wrong</Title>
			<Description>{message || ErrorMessages.GenericError} </Description>
			<StyledReloadButton type="button" onClick={reloadPage}>
				Reload Page <RefreshIcon aria-label="Refresh Icon" />
			</StyledReloadButton>
		</Root>
	);
}

export const Root = styled.div`
	padding: ${Css.pxToRem(100)};
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	align-items: center;

	p {
		max-width: ${Css.pxToRem(300)};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding: ${Css.pxToRem(90)} ${Css.pxToRem(24)} ${Css.pxToRem(50)};
	}
`;

export const Title = styled.h4`
	margin-bottom: 0;
	color: ${Color.OnBackground};
	line-height: normal;
	font-weight: 500;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRem(30)};
	}
`;

export const Description = styled.p`
	margin-bottom: ${Css.pxToRem(16)};
	font-weight: 300;
	font-size: ${Css.pxToRem(16)};
	color: ${Color.Neutral6};
`;

const StyledReloadButton = styled(TextButton)`
	cursor: pointer;
	color: ${(props) => props.theme.button?.secondary?.font?.color};
	font-size: ${Css.pxToRem(16)};

	&:hover {
		color: ${(props) => props.theme.button.textButton.hover.font.color};
	}

	svg {
		path {
			fill: currentColor;
		}
	}
`;
